var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 8.00065C13.1667 10.8541 10.8535 13.1673 8.00004 13.1673C5.14657 13.1673 2.83337 10.8541 2.83337 8.00065C2.83337 5.14718 5.14657 2.83398 8.00004 2.83398C10.8535 2.83398 13.1667 5.14718 13.1667 8.00065ZM14.6667 8.00065C14.6667 11.6825 11.6819 14.6673 8.00004 14.6673C4.31814 14.6673 1.33337 11.6825 1.33337 8.00065C1.33337 4.31875 4.31814 1.33398 8.00004 1.33398C11.6819 1.33398 14.6667 4.31875 14.6667 8.00065ZM8.75004 4.00065L8.75004 9.33398H7.25004L7.25004 4.00065H8.75004ZM8.66671 11.334C8.66671 11.7022 8.36823 12.0007 8.00004 12.0007C7.63185 12.0007 7.33337 11.7022 7.33337 11.334C7.33337 10.9658 7.63185 10.6673 8.00004 10.6673C8.36823 10.6673 8.66671 10.9658 8.66671 11.334Z",
    fill: "#3B1F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/moreInfo.b4cf75afc531b6c0d72704e667006e0a.svg";
export { ForwardRef as ReactComponent };